import { render } from "./DataBaseView.vue?vue&type=template&id=43c59583"
import script from "./DataBaseView.vue?vue&type=script&lang=js"
export * from "./DataBaseView.vue?vue&type=script&lang=js"

import "./DataBaseView.vue?vue&type=style&index=0&id=43c59583&lang=scss"

import exportComponent from "/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__